import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";

import Slideshow from "../../assets/Slideshow/Slideshow"; 




const Lo4Sum = () => {
    const navigate = useNavigate();

    const images = [figma, lowprot1, lowprot2];
    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo4-headings">
                <h1>Summary Process</h1>
                <p>Throughout this semester I have to show the milestones, decision, and what happened during each sprint</p>

                
            </div>

            <div className="line"></div>

            <div className="content-lo4">
                <div className="content-lo4-sum">
                    <div className="content-lo4-sum-text">
                    {/* <img src={gif2}></img> */}
                        <h1>Project Timeline</h1>
                        <p>
                            I was given a client for my group project from fontys to help Fonty's Marketing create a campaign for their new minor called Virtual Production
                        </p>
                        <h2>Sprint 1</h2>
                        <p>
                            During sprint 1 we as a group conducted a minor research for our topic, we also had our first interaction with our client Suzette as a representative
                            from Fonty's Marketing, we also prepared a meeting for our client.
                        </p>
                        <h2>Sprint 2</h2>
                        <p>
                            For this sprint we as a group went for a meeting with our client, created git, and did a small research how to promote a minor

                        </p>
                        <h2>Sprint 3</h2>
                        <p>
                            We gather information for our target audience definition, conducted interviews, wrote a Competitor analysis document, we also brainstorm our concept,
                            and discussed the HMW questions.
                        </p>
                        <h2>Sprint 4</h2>
                        <p>
                            We had a concept showcase of what we want to do for our clients, I also help in preparing the poster for our presentation that happened during this sprint,
                            we started making our concept document.
                        </p>
                        <h2>Sprint 5</h2>
                        <p>
                            During this sprint we finalized our concept, get a feedback from our client, and plan out task for the group.
                        </p>
                        <h2>Sprint 6</h2>
                        <p>
                            We work on each of the task that was assign to each member of the group, I was doing poster
                        </p>
                        <h2>Sprint 7</h2>
                        <p>
                            We created user stories, I work on the poster and 3D Poster for the client, We also had a display market where I helped Adib to field test our prototype.
                        </p>
                        <h2>Sprint 8</h2>
                        <p>
                            Not yet
                        </p>
                        
                    </div>

                    <div className="content-lo4-sum-slideshow">
                        <Slideshow images={images} />

                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo4Sum
;